module.exports = __webpack_public_path__ + "img/saveLQ.5e2a83e0.svg";